const thirty = [
  {
    name: 'add',
    type: '30',
    size: '30px'
  },
  {
    name: 'back-to-top',
    type: '30',
    size: '30px'
  },
  {
    name: 'bill',
    type: '30',
    size: '30px'
  },
  {
    name: 'chevron-down',
    type: '30',
    size: '30px'
  },
  {
    name: 'chevron-left',
    type: '30',
    size: '30px'
  },
  {
    name: 'chevron-right',
    type: '30',
    size: '30px'
  },
  {
    name: 'chevron-up',
    type: '30',
    size: '30px'
  },
  {
    name: 'close',
    type: '30',
    size: '30px'
  },
  {
    name: 'line',
    type: '30',
    size: '30px'
  },
  {
    name: 'link-arrow-left',
    type: '30',
    size: '30px'
  },
  {
    name: 'link-arrow-right',
    type: '30',
    size: '30px'
  },
  {
    name: 'organization',
    type: '30',
    size: '30px'
  },
  {
    name: 'page-next',
    type: '30',
    size: '30px'
  },
  {
    name: 'page-previous',
    type: '30',
    size: '30px'
  },
  {
    name: 'payment',
    type: '30',
    size: '30px'
  },
  {
    name: 'play',
    type: '30',
    size: '30px'
  },
  {
    name: 'rates',
    type: '30',
    size: '30px'
  },
  {
    name: 'recharges',
    type: '30',
    size: '30px'
  },
  {
    name: 'setup-product',
    type: '30',
    size: '30px'
  },
  {
    name: 'time',
    type: '30',
    size: '30px'
  },
];

export default thirty;



// WEBPACK FOOTER //
// ./src/containers/foundations/Icons/constants/thirty.js